export function Union({ value, symbol = "UNION" }) {
  return (
    <>
      {value} <span>{symbol}</span>
    </>
  );
}
